export const FETCH_PERMISSIONS = "FETCH_PERMISSIONS";
export const FETCH_PERMISSION = "FETCH_PERMISSION";
export const CREATE_PERMISSION = "CREATE_PERMISSION";
export const UPDATE_PERMISSION = "UPDATE_PERMISSION";
export const DELETE_PERMISSION = "DELETE_PERMISSION";

export function fetchPermissions(params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_PERMISSIONS,
    auth: true,
    payload: {
      url: "superuser/permissions",
      method: "GET",
      params
    }
  };
}

export function fetchPermission(id, params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_PERMISSION,
    auth: true,
    payload: {
      url: `superuser/permissions/${id}`,
      method: "GET",
      params
    }
  };
}

export function createPermission(data = {}) {
  return {
    type: CREATE_PERMISSION,
    auth: true,
    payload: {
      url: "superuser/permissions",
      method: "POST",
      data
    }
  };
}

export function updatePermission(id, data = {}) {
  return {
    type: UPDATE_PERMISSION,
    auth: true,
    payload: {
      url: `superuser/permissions/${id}`,
      method: "PUT",
      data
    }
  };
}

export function deletePermission(id, data = {}) {
  return {
    type: DELETE_PERMISSION,
    auth: true,
    payload: {
      url: `superuser/permissions/${id}`,
      method: "DELETE",
      data
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/permission.js